import { createTheme } from '@material-ui/core/styles'

const commonColors = {
    grey: {
        light: '#757575',
        main: '#333333',
        dark: '#212121',
        contrastText: '#FFF'
    },
    white: '#FFFFFF',
    black: '#000000',
    error: {
        light: '#E57373',
        main: '#F44336',
        dark: '#D32F2F',
        contrastText: '#ffffff'
    },
    danger: {
        light: '#E57373',
        main: '#F44336',
        dark: '#D32F2F',
        contrastText: '#ffffff'
    },
    warning: {
        light: '#FFB74D',
        main: '#FF9800',
        dark: '#F57C00',
        contrastText: '#ffffff'
    },
    success: {
        light: '#81C784',
        main: '#4CAF50',
        dark: '#388E3C',
        contrastText: '#ffffff'
    },
    info: {
        light: '#BBDEFB',
        main: '#2196F3',
        dark: '#0B79D0',
        contrastText: '#ffffff'
    }
}

const afiColorsOriginal = {
    primary: {
        light: '#017812',
        main: '#3BAD4C',
        dark: '#017812',
        contrastText: '#ffffff',
        background: '#9BC24C'
    },
    secondary: {
        light: '#FFAE86',
        main: '#E66728',
        dark: '#C74200',
        contrastText: '#ffffff',
        background: '#F9AE3B'
    },
    layout: {
        header: '#3BAD4C',
        background: '#E66728'
    }
}

const afiColors = {
    primary: {
        light: '#61ce70',
        main: '#61ce70',
        dark: '#61ce70',
        contrastText: '#ffffff',
        background: '#61ce70'
    },
    secondary: {
        light: '#f96828',
        main: '#f96828',
        dark: '#f96828',
        contrastText: '#ffffff',
        background: '#f96828'
    },
    layout: {
        header: '#f96828',
        background: '#dce8cf'
    } 
    
}

const fisaColors = {
    primary: {
        light: '#017812',
        main: '#3BAD4C',
        dark: '#017812',
        contrastText: '#ffffff',
        background: '#9BC24C'
    },
    secondary: {
        light: '#FFAE86',
        main: '#E66728',
        dark: '#C74200',
        contrastText: '#ffffff',
        background: '#F9AE3B'
    },
    layout: {
        header: '#D22630',
        background: '#D22630'
    }
}

const fisaBisColors = {
    primary: {
        light: '#BCE569',
        main: '#9BC24C',
        dark: '#6B8634',
        contrastText: '#ffffff',
        background: '#9BC24C'
    },
    secondary: {
        light: '#FFC978',
        main: '#FFAA2B',
        dark: '#E98C00',
        contrastText: '#ffffff',
        background: '#FFAA2B'
    },
    layout: {
        header: '#FFAA2B',
        background: '#FFAA2B'
    }
}

const aefColors = {
    primary: {
        light: '#9E4FA6',
        main: '#6D2077',
        dark: '#3F004B',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#FF7B46',
        main: '#FA4616',
        dark: '#BF0000',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#6D2077',
        background: '#6D2077'
    }
}

const afiazColors = {
    primary: {
        light: '#B2CBFF',
        main: '#49828B',
        dark: '#00256F',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#49828B',
        main: '#49828B',
        dark: '#2B828E',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#49828B',
        background: '#62A8C1'
    }
}

const afitxColors = {
    primary: {
        light: '#BAC7E1',
        main: '#5C6983',
        dark: '#1B366C',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#5C6983',
        main: '#5C6983',
        dark: '#3A727A',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#5C6983',
        background: '#5696AD'
    }
}

const crediconstruyeColors = {
    primary: {
        light: '#D2F3FF',
        main: '#65B3CF',
        dark: '#20586C',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#CEE9DD',
        main: '#218A59',
        dark: '#12472E',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#20586C',
        background: '#65B3CF'
    }
}

const tecnocreditoColors = {
    primary: {
        light: '#48466B',
        main: '#2F2F68',
        dark: '#20226B',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#A0C7C1',
        main: '#FFF',
        dark: '#56C6CC',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#FFF',
        background: '#FFF'
    }
}

const credialtoColors = {
    primary: {
        light: '#4A6299',
        main: '#255697',
        dark: '#1B4399',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#4D528F',
        main: '#30358E',
        dark: '#13388F',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#0C9DA9',
        background: '#00C3B3'
    }
}

const kahoolColors = {
    primary: {
        light: '#2E3541',
        main: '#1C2541',
        dark: '#0D1642',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#EB8484',
        main: '#E94B5A',
        dark: '#EB2A2A',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#E94B5A',
        background: '#EB8484'
    }
}

const prestaunicoColors = {
    primary: {
        light: '#9BDEF6',
        main: '#62A8C1',
        dark: '#50879A',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#EE6A8F',
        main: '#C7345D',
        dark: '#982847',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#982847',
        background: '#C7345D'
    }
}

const findepColors = {
    primary: {
        light: '#81B9FF',
        main: '#003B85',
        dark: '#002450',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#FF7B46',
        main: '#FA4616',
        dark: '#BF0000',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#002450',
        background: '#003B85'
    }
}

const pymefectivoColors = {
    primary: {
        light: '#155362',
        main: '#123D47',
        dark: '#002450',
        contrastText: '#ffffff'
    },
    secondary: {
        light: '#06A874',
        main: '#43AC3B',
        dark: '#BF0000',
        contrastText: '#ffffff'
    },
    layout: {
        header: '#43AC3B',
        background: '#E7EBDD'
    }
}

const dashboard = {
    background: {
        paper: '#fff',
        default: '#EAECF4'
    },
    palette: {
        common: {
            white: '#ffffff',
            black: '#212121'
        },
        layout: {
            header: '#1E1E2D',
            background: '#1A1A27'
        },
        primary: {
            main: '#6993FF',
            light: '#E1E9FF',
            dark: '#2866cb',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#8950FC',
            light: '#EEE5FF',
            dark: '#5020c8',
            contrastText: '#FFFFFF'
        },
        success: {
            main: '#1BC5BD',
            light: '#C9F7F5',
            dark: '#00948d',
            contrastText: '#ffffff'
        },
        warning: {
            main: '#FFA800',
            light: '#FFF4DE',
            dark: '#c67900',
            contrastText: '#212121'
        },
        danger: {
            main: '#F64E60',
            light: '#FFE2E5',
            dark: '#bd0536',
            contrastText: '#212121'
        },
        error: {
            main: '#F64E60',
            light: '#FFE2E5',
            dark: '#bd0536',
            contrastText: '#212121'
        },
        info: {
            main: '#8950FC',
            light: '#EEE5FF',
            dark: '#5020c8',
            contrastText: '#FFFFFF'
        },
        base: {
            main: '#E5EAEE',
            light: '#F3F6F9',
            dark: '#464E5F',
            contrastText: '#212121'
        },
        gray: {
            50: '#fafafa',
            100: '#F3F6F9',
            200: '#ECF0F3',
            300: '#E5EAEE',
            400: '#D6D6E0',
            500: '#B5B5C3',
            600: '#80808F',
            700: '#464E5F',
            800: '#1B283F',
            900: '#212121',
            A100: '#d5d5d5',
            A200: '#aaaaaa',
            A400: '#303030',
            A700: '#616161'
        }
    },
    shape: {
        borderRadius: 8
    },
    typography: {
        fontFamily: '"Poppins","Raleway","Poppins","Helvetica","Arial",sans-serif'
    }
}

const hawking = {
    primary: {
        light: '#BBDEFB',
        main: '#2196F3',
        dark: '#0B79D0',
        contrastText: '#ffffff',
        background: '#2196F3'
    },
    secondary: {
        light: '#FF7B46',
        main: '#FA4616',
        dark: '#BF0000',
        contrastText: '#ffffff',
        background: '#FA4616'
    },
    layout: {
        header: '#0B79D0'
    }
}

export const aefTheme = createTheme({
    palette: Object.assign({}, commonColors, aefColors)
})

export const afiTheme = createTheme({
    palette: Object.assign({}, commonColors, afiColors),
    typography: {
        fontFamily: [
          'Poppins',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif'
        ].join(','),
      }
})

export const afitxTheme = createTheme({
    palette: Object.assign({}, commonColors, afitxColors)
})


export const fisaTheme = createTheme({
    palette: Object.assign({}, commonColors, fisaColors)
})

export const fisaBisTheme = createTheme({
    palette: Object.assign({}, commonColors, fisaBisColors)
})

export const afiazTheme = createTheme({
    palette: Object.assign({}, commonColors, afiazColors)
})

export const crediconstruyeTheme = createTheme({
    palette: Object.assign({}, commonColors, crediconstruyeColors)
})

export const prestaunicoTheme = createTheme({
    palette: Object.assign({}, commonColors, prestaunicoColors)
})

export const tecnocreditoTheme = createTheme({
    palette: Object.assign({}, commonColors, tecnocreditoColors)
})

export const credialtoTheme = createTheme({
    palette: Object.assign({}, commonColors, credialtoColors)
})

export const kahoolTheme = createTheme({
    palette: Object.assign({}, commonColors, kahoolColors)
})

export const hawkingTheme = createTheme({
    palette: Object.assign({}, commonColors, hawking)
})

export const findepTheme = createTheme({
    palette: Object.assign({}, commonColors, findepColors)
})

export const pymefectivoTheme = createTheme({
    palette: Object.assign({}, commonColors, pymefectivoColors)
})

export const dashboardTheme = createTheme(dashboard)
